var React = require('react');

function StarEmpty (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.76 8.20762L22 8.43262L15.465 13.4765L17.7986 21.4117L11.0002 16.7326L4.20187 21.4117L6.53531 13.4758L0 8.43263L8.2403 8.20762L11.0002 0.411743L13.76 8.20762ZM12.6415 9.75286L11.0002 5.1166L9.35885 9.75286L4.45914 9.88666L8.34527 12.8855L6.95757 17.605L11.0002 14.8226L15.0427 17.6049L13.6551 12.8864L17.5415 9.88667L12.6415 9.75286Z","fill":"#C7C7C7"}));
}

StarEmpty.defaultProps = {"viewBox":"0 0 22 22","fill":"none"};

module.exports = StarEmpty;

StarEmpty.default = StarEmpty;
